export default "﻿<div class=\"TruckTable resourcePicker\">\n    \n</div>"